import { Result } from "./result";

export class EventConfig {
    number_of_rounds: number = 1;
    holes_played_per_round: number[] = [18];
    total_holes: number = 18;

    constructor(private eventResult: Result) {
        if (eventResult && eventResult.rounds_holes_played) {
            this.number_of_rounds = eventResult.rounds_holes_played.split(',').length;
            this.holes_played_per_round = eventResult.rounds_holes_played.split(',').map(x => +x);
            this.total_holes = 0;
            for (var i in this.holes_played_per_round) {
                this.total_holes += this.holes_played_per_round[i]
            }
        }
    }

    playing(): boolean {
        return (+this.eventResult.holes_played !== -1 && +this.eventResult.holes_played !== 0 && +this.eventResult.holes_played != this.total_holes)
    }

    completed(): boolean {
        return (+this.eventResult.holes_played === -1 || +this.eventResult.holes_played == this.total_holes);
    }

    notStarted(): boolean {
        return +this.eventResult.holes_played === 0;
    }

}